module.exports = __webpack_public_path__ + "static/img/vimeo-logo.ccd1762.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/icon/vimeo-logo.svg
// module id = 7ZAo
// module chunks = 0